import http from '../http-common';

/**
 * Client for the backend version endpoint (M0 contract).
 *
 * `GET utils/version` returns the bare body
 * `{ tool_version, build_sha, ai_service: { tool_version, build_sha, engines, schema_versions } | null }`;
 * `ai_service` is null when Flask is unreachable, so callers must handle that case.
 */
class VersionService {
  /**
   * @returns {Promise} resolves the Node + ai-service version block
   */
  get() {
    return http.get('utils/version');
  }

  /**
   * `GET utils/engine-changelog` proxies the static changelog shipped with the ai-service:
   * `{ "<engine>": [{ version, date, changes: string[] }] }`, versions descending.
   * Node answers null when Flask is unreachable, so callers must handle an empty body.
   *
   * @returns {Promise}
   */
  engineChangelog() {
    return http.get('utils/engine-changelog');
  }
}

export default new VersionService();
